import { useMatomo } from '@datapunt/matomo-tracker-react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useTrackMatomoCompanyId } from '@/core/matomo/useTrackMatomoCompanyId';
import { useTrackMatomoUserId } from '@/core/matomo/useTrackMatomoUserId';
import { useSetPendingView } from '@/core/store/recentHistory/recentHistorySelectors';
import { useHideTouchEditVisible } from '@/core/store/touchEdit/touchEditSelectors';

import { scrollBackToTop } from '../scrollBackToTop';

export const useRouteActions = () => {
	const { pathname, search } = useLocation();
	const setPendingView = useSetPendingView();
	const hideTouchEditVisible = useHideTouchEditVisible();
	const { trackPageView } = useMatomo();

	useTrackMatomoUserId();
	useTrackMatomoCompanyId();

	useEffect(() => {
		trackPageView({});
	}, [pathname, search, trackPageView]);

	useEffect(() => {
		scrollBackToTop();
		setPendingView(null); // Note (Ben): Required to clear the pending view used by RecentHistory.
		hideTouchEditVisible();
	}, [pathname, setPendingView, hideTouchEditVisible]);

	return null;
};
